export default __webpack_public_path__ + "static/media/ios-s1.0abc24a2.webp";